export default "__VITE_ASSET__BSAKUWoY__"